import React, { useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { contactFieldsQuery } from 'src/editor/api/queries/contact-fields-query'
import { SettingsMenuItem } from 'src/editor/shared/components/settings-menu-buttons/settings-menu-item'
import { defaultContactFieldsSlugs } from 'src/editor/shared/constants/contact-fields-slugs'
import { ChevronDownIcon } from 'src/editor/shared/icons/chevron-down-icon'
import { Tool02Icon } from 'src/editor/shared/icons/tool-02-icon'
import { Toggle } from 'src/editor/shared/ui-lib/toggle'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { twMerge } from 'tailwind-merge'
import { FormAddNewSubEntitySettingsItem } from './form-add-new-sub-entity-settings-item'

const buttonClassNames =
  'flex min-h-9 w-full cursor-pointer items-center justify-between rounded-md px-0.5 disabled:cursor-default'

const ButtonSkeleton = () => (
  <div className={buttonClassNames}>
    <span className="flex items-center gap-2 text-M">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-sm bg-black/5">
        <Skeleton width={20} height={20} borderRadius={9999} />
      </span>
      <Skeleton width={124} />
    </span>
    <Skeleton width={20} height={20} borderRadius={9999} />
  </div>
)

interface FormAddNewCustomFieldSubEntitySettingsProps {
  onToggle: (slug: ContactSlugEnum, fieldName?: string) => void
  getIsExisted: (slug: ContactSlugEnum) => boolean
}

export const FormAddNewCustomFieldSubEntitiesSettings = ({
  onToggle,
  getIsExisted,
}: FormAddNewCustomFieldSubEntitySettingsProps) => {
  const [isCustomFieldsOpen, setIsCustomFieldsOpen] = useState(false)

  const { data: contactFields, isLoading } = contactFieldsQuery.useQuery()

  const customContactFields = contactFields?.filter(
    field => !defaultContactFieldsSlugs.includes(field.slug),
  )

  return (
    <div className="flex flex-col gap-2">
      {isLoading ? (
        <ButtonSkeleton />
      ) : (
        <button
          type="button"
          className={buttonClassNames}
          onClick={() => setIsCustomFieldsOpen(prev => !prev)}
        >
          <SettingsMenuItem
            title="entity_settings.form.add_new_sub_entity.custom_fields.header"
            icon={Tool02Icon}
          />
          <ChevronDownIcon
            className={twMerge(
              'transition-transform duration-300',
              isCustomFieldsOpen ? 'rotate-180' : '',
            )}
          />
        </button>
      )}
      {isCustomFieldsOpen &&
        !isLoading &&
        customContactFields?.map(field => (
          <FormAddNewSubEntitySettingsItem
            key={field.slug}
            title={field.fieldName}
            skipTranslation
            settingsMenuItemTitleClassName="text-textSecondary"
            controlComponent={() => (
              <Toggle
                onChange={() => onToggle(field.slug, field.fieldName)}
                checked={getIsExisted(field.slug)}
              />
            )}
          />
        ))}
    </div>
  )
}
